import { useEffect } from "react";
import { useGetContext } from "@onefront/forrestjs-react-root";
import { useQueryString } from "../utils/use-query-string";
import { useStateSession } from "../service-state";
import { useVaporTheme } from "./ThemeProvider";

export const ThemeGate = () => {
  const { theme, setTheme } = useVaporTheme();

  const urlParam = useGetContext("one.vapor.theme.url.param");
  const sessionParam = useGetContext("one.vapor.theme.url.param");

  const [sessionTheme, setSessionTheme] = useStateSession(sessionParam);

  const qs = useQueryString();
  const requestedTheme = qs.getItem(urlParam);

  // Read item from url
  useEffect(() => {
    if (requestedTheme) {
      setTheme(requestedTheme);
      setSessionTheme(requestedTheme);
      qs.removeItem(urlParam);
    }
  }, []);

  // Read item from session
  useEffect(() => {
    if (!sessionTheme) return; // skip if no session theme
    if (requestedTheme) return; // skip if url param exist

    setTheme(sessionTheme);
  }, []);

  // Persist a change of theme into the session
  useEffect(() => {
    setSessionTheme(theme);
  }, [theme]);

  return null;
};
